import React from 'react';
import { siteInfo } from '../constants/siteInfo';
import type { OpeningHours } from '../constants/siteInfo';
import { FaCalendarAlt, FaSun, FaFish, FaUtensils } from 'react-icons/fa';

const OpeningHoursInfo: React.FC = () => {
  const { standard, special } = siteInfo.openingHours;

  const renderHours = (service: 'restaurant' | 'etangs', day: OpeningHours) => {
    const hours = day.services?.[service]?.[0];
    return hours ? `${hours.open}h - ${hours.close}h` : <span className="text-gray-400">Fermé</span>;
  };

  return (
    <div className="space-y-6">
      <div className="text-center bg-gray-50 p-3 rounded-lg">
        <p className="text-base font-semibold text-primary">{siteInfo.seasonText}</p>
      </div>
      
      {/* Saison Standard */}
      <div>
        <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
          <FaCalendarAlt className="mr-3 text-accent" />
          Saison Standard
        </h3>
        <div className="overflow-x-auto rounded-lg border border-gray-200">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100">
              <tr>
                <th scope="col" className="px-4 py-2">Jour</th>
                <th scope="col" className="px-4 py-2">Restaurant</th>
                <th scope="col" className="px-4 py-2">Étangs</th>
              </tr>
            </thead>
            <tbody>
              {standard.map((day, index) => (
                <tr key={day.day} className={`border-b ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-accent/10`}>
                  <td className="px-4 py-2 font-medium text-gray-900">{siteInfo.daysOfWeek[day.day]}</td>
                  <td className="px-4 py-2">{renderHours('restaurant', day)}</td>
                  <td className="px-4 py-2">{renderHours('etangs', day)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Haute Saison */}
      <div>
        <h3 className="text-lg font-bold text-gray-800 mb-2 flex items-center">
          <FaSun className="mr-3 text-accent" />
          Été (14/07 - fin Août) & Jours Fériés
        </h3>
        <div className="bg-primary/10 p-4 rounded-lg border-l-4 border-accent">
          <p className="font-semibold text-primary mb-2">Ouvert tous les jours :</p>
          <ul className="space-y-2 text-gray-800">
            <li className="flex items-center">
              <FaUtensils className="mr-3 w-4 text-primary/80" />
              <span className="font-medium">Restaurant :</span>
              <span className="ml-2 font-bold">{special.restaurant?.[0].open}h - {special.restaurant?.[0].close}h</span>
            </li>
            <li className="flex items-center">
              <FaFish className="mr-3 w-4 text-primary/80" />
              <span className="font-medium">Étangs :</span>
              <span className="ml-2 font-bold">{special.etangs?.[0].open}h - {special.etangs?.[0].close}h</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OpeningHoursInfo; 